// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/cdee362498953e90547d.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"f010dfa0b76ec3944f87","265":"3e7562a68c0921653541","266":"b3d235322a0fcc4bd581"}[chunkId] + ".chunk.js";
};